import axios, { AxiosResponse } from 'axios';
import { apiClient } from '../apiClient';
import { Site } from '../sites/sites';

export interface SiteDailyReport {
    _id: string;
    siteId: Site;
    date: string;
    globalObservations: string;
    updatedAt?: string;
    createdAt?: string;
}

export interface SiteDailyReportResponse {
    message: string;
    data?: SiteDailyReport;
}

export interface UpsertSiteDailyReportBody {
    siteId: string;
    date: string;
    globalObservations?: string;
}

export interface GetSiteDailyReportQueries {
    siteId: string;
    date: string;
}

export const upsertSiteDailyReport = async (data: UpsertSiteDailyReportBody): Promise<SiteDailyReportResponse> => {
    try {
        const response: AxiosResponse<SiteDailyReportResponse> = await apiClient.post('/site-daily-reports/upsert', data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export const getSiteDailyReportBySiteAndDate = async (queries: GetSiteDailyReportQueries): Promise<SiteDailyReportResponse> => {
    try {
        const response: AxiosResponse<SiteDailyReportResponse> = await apiClient.get('/site-daily-reports/site-date', {
            params: queries,
        });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};
